import { StaticRoutingModule } from './static-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    declarations: [HomeComponent],
    imports: [CommonModule, SharedModule, StaticRoutingModule],
})
export class StaticModule {}
